import { getInitialState, getPath } from "../../utils";
import ActionTypes from "../actions/ActionTypes";

const initialState = {
  driverBannerList: [],
  activeFilters: {},
  driverBannerDetails: {},
  page_response: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_DRIVER_BANNER_LIST:
      return setDriverBannerList(state, action);
    case ActionTypes.SET_ACTIVE_FILTERS_DRIVER_NOTIFICATION:
      return setActiveFilters(state, action);
    case ActionTypes.RESET_STATE:
      return resetState(state, action);
    case ActionTypes.SET_BANNER_DETAILS:
      return setBannerDetails(state, action);
    case ActionTypes.SET_TARGET_AUDIENCE:
      return setTargetAudience(state, action);
    case ActionTypes.SET_TARGETABLE_BUSINESS:
      return setTargetableBusiness(state, action);
    default:
      return state;
  }
}

const setTargetAudience = (state, action) => {
  return {
    ...state,
    targetAudience: action.payload,
  };
};

const setTargetableBusiness = (state, action) => {
  return {
    ...state,
    targetableBusiness: action.payload,
  };
};

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};

const setDriverBannerList = (state, action) => {
  return {
    ...state,
    driverBannerList: getPath(action.payload, "banner_details", []),
    page_response: getPath(action.payload, "page_response", {}),
  };
};

const setActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};

const setBannerDetails = (state, action) => {
  return {
    ...state,
    driverBannerDetails: getPath(action.payload, "driver_banner_details", {}),
  };
};
